import React from 'react';
import PropTypes from 'prop-types';

import Card from '../shared/Card';
import Stat from './Stat';
import './EngagementOverview.css';

const EngagementOverview = ({
  participationCount,
  totalHours,
  totalEvents,
  impactScore,
  participationTrend,
  impactTrend,
  loading,
}) => {
  const formatCurrency = (value) => `$${value?.toLocaleString()}`;

  return (
    <Card title="Overview">
      <div className="tw-stats-row">
        <Stat
          label="User participation"
          value={participationCount}
          trend={participationTrend}
          loading={loading}
        />
        <Stat
          label="Total hours"
          value={totalHours}
          loading={loading}
        />
        <Stat
          label="Total number of events"
          value={totalEvents}
          loading={loading}
        />
        <Stat
          label="Impact score"
          value={impactScore}
          trend={impactTrend}
          formatValue={formatCurrency}
          loading={loading}
        />
      </div>
    </Card>
  );
};

EngagementOverview.propTypes = {
  participationCount: PropTypes.number,
  totalHours: PropTypes.number,
  totalEvents: PropTypes.number,
  impactScore: PropTypes.number,
  participationTrend: PropTypes.number,
  impactTrend: PropTypes.number,
  loading: PropTypes.bool,
};

EngagementOverview.defaultProps = {
  participationCount: 0,
  totalHours: 0,
  totalEvents: 0,
  impactScore: 0,
  participationTrend: null,
  impactTrend: null,
  loading: false,
};

export default EngagementOverview;
